import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import FolderCopy from "../screens/CategoryManagement/FolderCopy"

const breadCrumbData = [{ link: "/folder-copy", name: "Folder Copy" }];

const Home = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <FolderCopy />
    </LayoutContainer>
  </>
);

export default Home;